export default __webpack_public_path__ + "static/media/bigLogo.51ee332c.svg";